import d from "./node_modules/mitt/dist/mitt.mjs";export default d;